export const environment = {
  apiBaseUrl: 'https://testapi.felix.no',
  appUrl: 'https://test.felix.no',
  authority: 'https://connect.identity.stagaws.visma.com',
  clientId: 'fenistra-felix',
  redirectUri: 'https://testonboarding.felix.no/auth/callback',
  scope: 'openid profile email',
  acrValues: {
    linkedin: 'urn:visma:external_idp:linkedin',
    google: 'urn:visma:external_idp:google',
    microsoft: 'urn:visma:external_idp:microsoft',
  },
  clarityProjectId: '',
  clarityHostnames: [] as string[],
};
